import { useCallback, useMemo, useSyncExternalStore } from 'react';
import { Query } from 'firebase/firestore';
import { subscribeToQuery, getSnapshot } from '../stores/firestore';

export function useFirestoreCollection<T>(key: unknown[], query: Query): T[] {
  const storeKey = useMemo(() => JSON.stringify(key), [key]);

  const subscribe = useCallback(
    (callback: () => void) => subscribeToQuery(storeKey, query, callback),
    [query, storeKey],
  );

  const getSnapshotCallback = useCallback(() => getSnapshot<T>(storeKey), [storeKey]);

  return useSyncExternalStore(subscribe, getSnapshotCallback);
}
